module.exports = __webpack_public_path__ + "img/logo_claro.27a6d51d.png";